import { render, staticRenderFns } from "./SupportSettings.vue?vue&type=template&id=2313a8ce&scoped=true&lang=pug"
import script from "./SupportSettings.vue?vue&type=script&lang=js"
export * from "./SupportSettings.vue?vue&type=script&lang=js"
import style0 from "./SupportSettings.vue?vue&type=style&index=0&id=2313a8ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2313a8ce",
  null
  
)

export default component.exports